import { icons } from "../assets";
import { IconBookings, IconCampaign, IconLogout, IconMail, IconOrders, IconProducts, IconSettings, IconShop, IconUsers } from "./adminIcons";
import { navigateAdminSection } from "./adminRouting";

const NAV_ITEMS = [
  { id: "subscribers", label: "Feliratkozók", icon: IconUsers },
  { id: "bookings", label: "Foglalások", icon: IconBookings },
  { id: "orders", label: "Rendelések", icon: IconOrders },
  { id: "preview", label: "E-mail teszt", icon: IconMail },
  { id: "campaigns", label: "Kampányok", icon: IconCampaign },
  { id: "shop", label: "Webshop", icon: IconShop },
  { id: "products", label: "Termékek", icon: IconProducts },
  { id: "settings", label: "Beállítások", icon: IconSettings },
];

function getInitials(name) {
  const parts = String(name || "A").trim().split(/\s+/);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return String(name || "A").slice(0, 2).toUpperCase();
}

function AdminShell({ section, adminUsername, onLogout, children }) {
  const displayName = adminUsername || "Admin";

  return (
    <div className="admin-dash">
      <aside className="admin-dash-sidebar">
        <div className="admin-dash-sidebar-brand">
          <img src={icons.logo} alt="" className="admin-dash-sidebar-logo" />
          <span className="admin-dash-sidebar-sub">Brunch &amp; Coffee</span>
        </div>

        <nav className="admin-dash-nav" aria-label="Admin navigáció">
          {NAV_ITEMS.map((item) => {
            const Icon = item.icon;
            const isActive = section === item.id;
            return (
              <button
                key={item.id}
                type="button"
                className={`admin-dash-nav-item${isActive ? " is-active" : ""}`}
                aria-current={isActive ? "page" : undefined}
                onClick={() => navigateAdminSection(item.id)}
              >
                <Icon />
                {item.label}
              </button>
            );
          })}
        </nav>

        <div className="admin-dash-sidebar-foot">
          <div className="admin-dash-profile">
            <span className="admin-dash-avatar">{getInitials(displayName)}</span>
            <div>
              <p className="admin-dash-profile-welcome">Üdvözlünk!</p>
              <p className="admin-dash-profile-name">{displayName}</p>
              <p className="admin-dash-profile-role">Rendszergazda</p>
            </div>
          </div>
          <button type="button" className="admin-dash-logout" onClick={onLogout}>
            <IconLogout />
            Kijelentkezés
          </button>
        </div>
      </aside>

      <div className="admin-dash-main">{children}</div>
    </div>
  );
}

export default AdminShell;
